import "./maff.css";
import fest from "./img/fest.png";
import ImageCard from "./ImageCard";

function App() {
  return (
    <>
      <ImageCard />
    </>
  );
}

export default App;